
import { defineComponent, SetupContext } from "vue";
export default defineComponent({
  name: "SearchDropdownButtonItem",
  props: {
    /**
     * 選択項目名
     */
    label: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    /**
     * 選択された項目を通知する
     */
    const onClick = () => {
      context.emit("select-item", props.label);
    };

    return {
      onClick
    };
  }
});
